import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360Validator } from "./F360Validator";

@injectable()
export default class F360CLIValidator implements IF360Validator<string> {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(codigo: string): boolean {
    const isCurrentCLI = this.userProfileMixin.handleGetUserProfile()
      ?.CodigoCliente
      ? this.userProfileMixin
          .handleGetUserProfile()
          ?.CodigoCliente?.indexOf(codigo) !== -1
      : false;

    return isCurrentCLI;
  }
}
